import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";
import authServices from "./auth";
import organizationServices from "./organization";

function list(params) {
  return request({
    url: ENDPOINT.DATA_CONFIG,
    method: "get",
    params,
  });
}

function setAllConfigs(data) {
  localStorage.setItem("all_configs", JSON.stringify(data));
}

function getAllConfigs() {
  try {
    return JSON.parse(localStorage.getItem("all_configs")) || [];
  } catch (_) {
    return [];
  }
}

async function setStorageConfigs() {
  const loginInfo = authServices.loginInfo();
  if (loginInfo) {
    await list({
      offset: 0,
      limit: 999,
      filters: {
        'extra.organization_id': organizationServices.getCurrentOrg()?.id
      }
    }).then((response) => {
      const allConfigs = response.items.filter((i) => i.extra?.is_publish);
      const currentOrg = organizationServices.getCurrentOrg();
      const newConfigs = allConfigs.map((c) => {
        return {
          ...c,
          extra: {
            ...c.extra,
            modules: (c.extra.modules || []).filter((m) => {
              if (!m.roles || m.roles.length <= 0 || currentOrg.management_role_allow_all) {
                return true;
              }
              return m.roles.includes(currentOrg.management_roles_id)
            })
          }
        }
      })
      const oldConfig = getAllConfigs();
      if (JSON.stringify(oldConfig) !== JSON.stringify(newConfigs)) {
        setTimeout(() => {
          window.location.reload();
        }, 50)
      }
      setAllConfigs(newConfigs);
    }).catch(() => {
      setAllConfigs([])
    })
  }
}

export default {
  list,
  setAllConfigs,
  getAllConfigs,
  setStorageConfigs
};
